module.exports = __webpack_public_path__ + "static/media/DuPontLogo_PaleGrey.7fb11fb6.svg";